export default "__VITE_ASSET__BXgiEgRA__"